import { render, staticRenderFns } from "./BusinessCard.vue?vue&type=template&id=0a679532&scoped=true"
import script from "./BusinessCard.vue?vue&type=script&lang=ts"
export * from "./BusinessCard.vue?vue&type=script&lang=ts"
import style0 from "./BusinessCard.vue?vue&type=style&index=0&id=0a679532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a679532",
  null
  
)

export default component.exports